// @mui
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";

// types

import { Iconify } from "../../components";
import { useRecoilState, useRecoilValue } from "recoil";
import { filterSelectedAttributeIdsSelector, filterWidgetShownAtom } from "../../../state/search-state";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "../../../fe-ui/hooks/use-translation";

type Props = {
  type?: "compact";
};

export function SidebarFilterButtonWidget({ type }: Props) {
  const isCompact = type === "compact";
  const [, setShown] = useRecoilState(filterWidgetShownAtom);
  const canReset = useRecoilValue(filterSelectedAttributeIdsSelector);
  const t = useTranslation();
  if (isCompact) {
    return (
      <Tooltip title={t("cta_open_sidebar_filters")}>
        <IconButton onClick={() => setShown(true)} data-testid="filter-button">
          <Badge color={"error"} variant={"dot"} invisible={canReset.length === 0}>
            <Iconify icon={"ic:round-filter-list"} />
          </Badge>
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <Button
        disableRipple
        color={"inherit"}
        data-testid="filter-button"
        endIcon={
          <Badge color={"error"} variant={"dot"} invisible={canReset.length === 0}>
            <Iconify icon={"ic:round-filter-list"} />
          </Badge>
        }
        onClick={() => setShown(true)}
      >
        {!isCompact && "Filters"}
      </Button>
    </>
  );
}
